import { TOKEN_TYPE } from "../entities/Constants";

export default class SessionStorageService {
    
    static loginUser: { userIdKey: any; usertoken: string;expiryAt:string };
    
    static getAccessToken(type: TOKEN_TYPE): string {
        const idTokenKey = SessionStorageService.findKey(type);
        const idTokeValue = sessionStorage.getItem(idTokenKey);

        if (idTokeValue) {
            const userInfoObject = JSON.parse(idTokeValue);
            const usertoken = userInfoObject?.secret;
            return usertoken;
        }

        return null;
    }

    static getUserId() {
        let userInfoString = null;
        const idTokenKey = SessionStorageService.findUserNameKey();
        if (idTokenKey) {
            userInfoString = sessionStorage.getItem(idTokenKey);
            let userInfoObject = JSON.parse(userInfoString);
            const userIdKey = userInfoObject["username"];
            return userIdKey;
        }

    }
    static getUserName() {
        let userInfoString = null;
        const idTokenKey = SessionStorageService.findUserNameKey();
        if (idTokenKey) {
            userInfoString = sessionStorage.getItem(idTokenKey);
            let userInfoObject = JSON.parse(userInfoString);
            const userIdKey = userInfoObject["name"];
            return userIdKey;
        }

    }
    static findKey(type: TOKEN_TYPE):string{
        const msalKey = "msal.token.keys." + process.env.clientId;
        const allKeyObjectString = sessionStorage.getItem(msalKey);
        const keyObject = JSON.parse(allKeyObjectString);
        if(keyObject){
            return type === TOKEN_TYPE.API 
                ? Array.from(keyObject["accessToken"]).filter(p=>(p as string).indexOf("api://")>-1)[0] as string
                : Array.from(keyObject["accessToken"]).filter(p=>(p as string).indexOf("user.read")>-1)[0] as string;
        }
      
        return null;
    }

    static findUserNameKey():string{
        const msalKey = "msal.account.keys";
        const allKeyObjectString = sessionStorage.getItem(msalKey);
        const keyObject = JSON.parse(allKeyObjectString);
        if(keyObject){
           return keyObject[0];
        }
     
        return null;
    }
}